var oshPark = {
    OTT: 153,
    OTW: 153,
    OTP: 200,
    OPP: 200,
    OAR: 178,
    min_copper_to_boarder: 382,
    pthMinEndsize: 250,
    npthMinEndsize: 330.2,
    minMilSize: 889,
    viaMinEndsize: 250,
    silkscreenMinWidth: 170
};
module.exports.oshPark = oshPark;
